/* unplugin-vue-components disabled */import script from "./BadgeDot.vue?vue&type=script&lang=ts&setup=true"
export * from "./BadgeDot.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__